import { color } from 'framer-motion';
import { css } from 'styled-system/css';

export const topBarStyles = {
	topBar: css({
		_mars: {
			'& .single-topbar__wrap': {
				color: 'white',
				backgroundColor: 'primary.800',
				'& .btn--icon': {
					color: 'whiteOpacity.100'
				},
				'& .btn--icon .icon--arrow-left': {
					color: 'currentColor'
				},
				'& [class*=icon--home]': {
					color: 'whiteOpacity.100'
				},
				'& .icon--dropdown': {
					color: 'whiteOpacity.70'
				},

				// # 13085 修正此元素在mars and topBar下的顏色
				'& .match-time-live': {
					color: 'var(--colors-white-opacity-70)',
				},
				'& .team-score': {
					color: 'var(--colors-secondary-500)'
				},
				'& .text-primary': {
					color: 'var(--colors-minus-text)'
				},
			},
			'& .single-topbar__content': {

			},
			'& .single-topbar__info': {

			},
			'& .single-topbar__league': {
				color: 'white',
			},
			'& .single-topbar__match': {
				color: 'white',
			},
			'& .team-name, .team-vs__score, .team-vs__status, .match-time': {
				color: 'white',
			},
			'& .select-match': {
				left: '0',
				right: '0',
				borderTopLeftRadius: '0',
				borderTopRightRadius: '0',
			},
			'& .select-match__list': {
				backgroundColor: 'selectMatch.list.bg',
				borderColor: 'black.5',
			},
			'& .select-match__league': {
				fontSize: '14px',
				color: 'black.1',
			},
			'& .select-match__sub-list': {
				backgroundColor: 'selectMatch.subList.bg',
			},
			'& .select-match-item': {
				borderColor: 'black.5',
				color: 'black.1',
				_active: {
					backgroundColor: 'selectMatch.item.activeBg',
					'& .team-name': {
						color: 'brand.500',
					},
				},
				'& .team-name': {
					color: 'black.1',
					fontWeight: '500',
				},
			},
			'& .select-match-item__scores': {
				color: 'secondary.500',
			},
			// NOTE: Scoreboard in single match sticky to top
			'& .scoreboard': {
				backgroundColor: 'black',
				'& [class^=scoreboard__col]': {
					color: 'whiteOpacity.70',
					'& .scoreboard__text--base': {
						color: 'whiteOpacity.100',
						bgColor: 'whiteOpacity.30',
					},
					'& .scoreboard__text-group': {
						'--scoreboard-cell-heading-text': 'currentColor',
					},
				},
			},
			'& .scoreboard__cell-heading': {
				color: 'whiteOpacity.70',
				backgroundColor: 'whiteOpacity.30'
			},
			'& [class^=scoreboard__col]': {
				color: 'whiteOpacity.100',
			},
			'& .scoreboard__btn .btn--icon .icon--dropdown': {
				color: 'white.3',
			},
			'& .team-vs__score': {
				color: 'secondary.500',
			},
		}
	}),
	topBarInAside: css({
		_mars: {
			'& .team-vs__score': {
				color: 'secondary.500',
			},
			'& .single-topbar__content': {
				borderWidth: 0,
			}
		}
	})
}